import {checkBit} from '@/common/helpers/utils/bitMask';

export function parseLocationFlags(flagsMask: number) {
	return {
		countryAdminCenter: checkBit(flagsMask, 0),
		regionAdminCenter: checkBit(flagsMask, 1),
		districtAdminCenter: checkBit(flagsMask, 2),
		subdistrictAdminCenter: checkBit(flagsMask, 3),
		parentOfSettlements: checkBit(flagsMask, 4),
		parentOfRegion: checkBit(flagsMask, 5),
		parentOfDistrict: checkBit(flagsMask, 6),
		parentOfSubDistrict: checkBit(flagsMask, 7),
	};
}
